import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Tabs,
    useCRUDController,
    Select,
    Button,
    MainModal,
    Modal,
    Form,
    message,
    PostButton,
    patchData,
    DeleteButton,
    PatchButton
} from "../../ui/ot";
import { useTranslation } from "react-i18next";
import { Star, Settings } from "lucide-react"
import { useSearchParams } from "react-router-dom";
import BudgetAndQuantityControlForm from './budget_and_quantity_control_form'
import { DollarSign, PieChart, Users } from 'lucide-react';

const BudgetAndQuantityControl = ({
    keyPrefix = "cataloging.budget_and_quantity_control",
    onChange = () => { }
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [modalOpen, setModalOpen] = useState(false)
    const [budgetControl, setBudgetControl] = useState({
        user_id: "",
        staff_id: "",
        branchcode: "",
        branchname: ""
    })

    const BudgetControlController = useCRUDController({
        apiRoute: "/cataloging/budget_control"
    })

    const getBudgetControl = () => {
        BudgetControlController.getData({})
            .then((response) => {
                let data = response?.data || []
                let year = new Date().getFullYear();
                let firstData = data?.find((ele) => ele?.year === year)
                if (!firstData) {
                    firstData = data?.find((ele) => true)
                }
                let remainingAmount = firstData?.estimate_cost - firstData?.actual_cost;
                let usagePercentage = (firstData?.actual_cost / firstData?.estimate_cost) * 100;
                setBudgetControl({
                    ...firstData,
                    remainingAmount,
                    usagePercentage
                })
            })
    }
    useEffect(() => {
        getBudgetControl()
    }, [])
    useEffect(() => {
        onChange(budgetControl)
    }, [budgetControl])
    return (<Row gutter={[4, 4]} align="middle">
        <Modal
            axiosMode={'patch'}
            open={modalOpen}
            width={800}
            keyPrefix={keyPrefix}
            onClose={() => {
                setModalOpen(false)
                getBudgetControl()
            }}
            close={true}
            closeText="關閉"
        >
            <Row gutter={[8, 8]}>
                <Col span={24}>
                    <Budget />
                </Col>
            </Row>
        </Modal>
        <Col span={24}>
            <Row justify="space-between">
                <Col >
                    <Typography.Title level={4}>
                        {budgetControl?.year}{t('annual_budget_overview')}
                    </Typography.Title>
                </Col>
                <Col >
                    <Button type="text" onClick={() => {
                        setModalOpen(true)

                    }} >
                        <Settings /> {t('edit')}
                    </Button>
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <BudgetDisplay budget={budgetControl} direction={"horizontal"} />
        </Col>

    </Row>)
}
const Budget = ({
    propsBudget,
    keyPrefix = "cataloging.budget_and_quantity_control",

}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [budget, setBudget] = useState(propsBudget)
    const [axiosFormMode, setAxiosFormMode] = useState("get")

    const [form] = Form.useForm();
    const onFormFinish = (value) => {
        if (axiosFormMode === "post") {
            BudgetControlController.postData([
                value
            ])
        }
        else if (axiosFormMode === "patch") {
            BudgetControlController.patchData([
                value
            ])
        }

    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                getBudgetControl()
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                getBudgetControl()
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                getBudgetControl()

            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                getBudgetControl()
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                getBudgetControl()
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                getBudgetControl()
            }
        }
    };
    const BudgetControlController = useCRUDController({
        apiRoute: "/cataloging/budget_control",
        onFinish: onFinish
    })
    const getBudgetControl = () => {
        BudgetControlController.getData({})
            .then((response) => {
                let data = response?.data || []
                let firstData = data?.find((ele) => true)
                let remainingAmount = firstData?.estimate_cost - firstData?.actual_cost;
                let usagePercentage = (firstData?.actual_cost / firstData?.estimate_cost) * 100;
                setBudget({
                    ...firstData,
                    remainingAmount,
                    usagePercentage
                })
                setAxiosFormMode('get')
                form.setFieldsValue({
                    ...firstData,
                    remainingAmount,
                    usagePercentage
                })
            })
    }
    useEffect(() => {
        getBudgetControl()
    }, [])

    return (
        <Row gutter={[8, 8]} justify={"center"}>
            <Col span={8} hidden={axiosFormMode === "get"}>
                <div className="bg-white p-6 rounded-lg shadow-lg w-full space-y-6">
                    <h2 className="text-2xl font-bold text-gray-900 text-center">
                        {axiosFormMode === "post" ? '新增' : '修改'}
                    </h2>
                    <BudgetAndQuantityControlForm
                        axiosMode={axiosFormMode}
                        propsForm={form}
                        onFormFinish={onFormFinish}
                    />
                    <Button
                        onClick={() => {
                            form.submit()
                        }}
                        block={true} >{t('submit')}</Button>
                </div>

            </Col>
            <Col span={16}>
                <div className="bg-white p-4 rounded-lg shadow-lg w-full space-y-4">
                    <h2 className="text-2xl font-bold text-gray-900 text-center">
                        {budget?.year}{t('annual_budget_overview')}
                    </h2>
                    <Row gutter={[4, 4]}>
                        <Col span={24}>
                            <Row gutter={[4, 4]}>
                                {
                                    BudgetControlController?.ResponseData?.map((val) => {
                                        return (
                                            <Col lg={4}>
                                                <Button
                                                    onClick={() => {
                                                        let remainingAmount = val?.estimate_cost - val?.actual_cost;
                                                        let usagePercentage = (val?.actual_cost / val?.estimate_cost) * 100;
                                                        setBudget({
                                                            ...val,
                                                            remainingAmount,
                                                            usagePercentage
                                                        })
                                                        form.setFieldsValue({
                                                            ...val,
                                                            remainingAmount,
                                                            usagePercentage,
                                                        })
                                                    }}
                                                    type={val?.budget_control_id === budget?.budget_control_id ? "" : "default"}
                                                    block={true}>{val?.year}</Button>
                                            </Col>
                                        )
                                    })
                                }
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Row gutter={[4, 4]} justify="end">
                                <Col>
                                    <PostButton
                                        onClick={() => {
                                            form.setFieldsValue({
                                                "year": null,
                                                "estimate_cost": 0,
                                                "actual_cost": 0,
                                                "remaining_budget": 0,
                                                "recommend_budget": 0,
                                            })
                                            setAxiosFormMode('post')

                                        }}
                                        ischildren={false} />
                                </Col>
                                <Col>
                                    <PatchButton
                                        onClick={() => {
                                            form.setFieldsValue({
                                                ...budget,
                                            })
                                            setAxiosFormMode('patch')
                                        }}
                                    />
                                </Col>
                                <Col>
                                    <DeleteButton
                                        onConfirm={() => {
                                            BudgetControlController.deleteData([
                                                {
                                                    ...budget
                                                }
                                            ])
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Col spa={24}>
                        <BudgetDisplay keyPrefix={keyPrefix} budget={budget} direction="vertical" />
                    </Col>

                </div>
            </Col>
        </Row>

    );
}
const BudgetDisplay = ({
    budget,
    direction = "vertical" , //vertical horizontal,
    keyPrefix = "cataloging.budget_and_quantity_control",
}) => {
    const { t } = useTranslation('translation', { keyPrefix })

    return (
        <div className={`grid ${direction === "vertical" ? "grid-cols-1" : "grid-cols-4"} gap-2`}>
            <div className="bg-indigo-50 p-4 rounded-lg">
                <div className="flex items-center space-x-3">
                    <DollarSign className="w-6 h-6 text-indigo-600" />
                    <h3 className="text-lg font-medium text-gray-900">
                        { t('annual_budget_overview')}</h3>
                </div>
                <p className="mt-2 text-2xl font-semibold text-indigo-600">
                    ${(budget?.estimate_cost || 0).toLocaleString()}
                </p>
            </div>

            <div className="bg-green-50 p-4 rounded-lg">
                <div className="flex items-center space-x-3">
                    <PieChart className="w-6 h-6 text-green-600" />
                    <h3 className="text-lg font-medium text-gray-900"> 
                    {t('actual_expense')}
                    </h3>
                </div>
                <p className="mt-2 text-2xl font-semibold text-green-600">
                    ${(budget?.actual_cost || 0).toLocaleString()}
                </p>
                <div className="mt-2 h-2 bg-gray-200 rounded-full">
                    <div
                        className="h-2 bg-green-600 rounded-full"
                        style={{ width: `${budget?.usagePercentage <= 100 ? budget?.usagePercentage : 100}%` }}
                    />
                </div>
                <p className="mt-1 text-sm text-gray-500">
                    {t('usage_rate')}: {(budget?.usagePercentage || 0).toFixed(1)}%
                </p>
            </div>
            <div className="bg-purple-50 p-4 rounded-lg">
                <div className="flex items-center space-x-3">
                    <DollarSign className="w-6 h-6 text-purple-600" />
                    <h3 className="text-lg font-medium text-gray-900">{t('remaining_budget')}</h3>
                </div>
                <p className="mt-2 text-2xl font-semibold text-purple-600">
                    ${(budget?.remaining_budget || 0).toLocaleString()}
                </p>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg">
                <div className="flex items-center space-x-3">
                    <Users className="w-6 h-6 text-blue-600" />
                    <h3 className="text-lg font-medium text-gray-900">{t('personal_recommendation_quota')}</h3>
                </div>
                <p className="mt-2 text-2xl font-semibold text-blue-600">
                    {budget?.recommend_budget} 本
                </p>
            </div>
        </div>
    )
}
export default BudgetAndQuantityControl

